import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { getScrollToRoute } from "src/routes/AppRouter";

import { HashLink } from "react-router-hash-link";

type NaveMenuItemProps = {
  section: string;
};

export default function EntainLogoButton(props: NaveMenuItemProps) {
  const { section } = props;
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <HashLink
      to={getScrollToRoute(section)}
      smooth
      style={{
        textDecoration: "none",
        position: "absolute",
        top: isMobileOrTablet ? 0 : 5,
        left: 0,
        width: "100%",
        height: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      aria-label="link to home page"
    >
      <img
        src="/images/entain/logo-white-word192.png"
        alt="Entain Logo"
        style={{ height: "120px", width: "120px" }}
      />
    </HashLink>
  );
}
